export enum Role {
  SCCService = 'SCCService',
  SCCCustomer = 'SCCCustomer',
  SCCManager = 'SCCManager',
}
